import { createFileRoute } from "@tanstack/react-router";
import { MarketingIdeasPage } from "../components/marketing/MarketingIdeasPage";
import { workflowsIndexPage } from "../marketing-content/automationIdeaHubs";
import { contentHead } from "../marketing-content/head";

export const Route = createFileRoute("/workflows")({
  head: () => contentHead(workflowsIndexPage()),
  component: MarketingIdeasPage,
});
